<div class="row">
    <!-- <div class="col-md-auto">
  <app-camp-icon [iconName]="item.categoryIcon"></app-camp-icon>
</div> -->
    <div class="col" (click)="onShowDetails()">
        <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1 main-blue bolded">{{ session.name }}</h6>
            <small class="text-muted">
                <div class="list-row-value bolded">
                    {{ session.startDate | bcDate }} -
                    {{ session.endDate | bcDate }},
                    {{
                        campsEnumTranslation.timeVariant(
                            session.timeVariant.type
                        )
                    }}
                    ({{ session.timeVariant.fromInMinutes | timeDisplay }} -
                    {{ session.timeVariant.toInMinutes | timeDisplay }})
                </div>
            </small>
        </div>
        <p class="mb-1 bolded">{{ session.clubName }}</p>
        <small class="text-muted"
            >{{ session.ageRangeFromInMonths | age }} -
            {{ session.ageRangeToInMonths | age }}</small
        >
    </div>
</div>

<div class="row">
    @if (showDetails) {
        <div class="col voffset-20">
            <tabset>
                @for (day of session.noOfDays; track day; let i = $index) {
                    <tab
                        [heading]="day.name"
                        (selectTab)="onDayVariantDetails(day.id)"
                    >
                        @if (isBusy) {
                            <div class="voffset-40">
                                <bcu-local-spinner
                                    [size]="50"
                                    [visible]="isBusy"
                                ></bcu-local-spinner>
                            </div>
                        }
                        @if (selectedDaysVariant) {
                            <div>
                                <div class="voffset-20">
                                    <app-days-variant-enrollment-item
                                        [daysVariant]="selectedDaysVariant"
                                    ></app-days-variant-enrollment-item>
                                </div>
                            </div>
                        }
                    </tab>
                }
            </tabset>
        </div>
    }
</div>
